import Dexie, { type Table } from 'dexie';
import type { UploadRecord } from '../models/upload-record.model';
import type { BulkJobProgress } from '../models/bulk-job-progress.model';

export class OnboardingDB extends Dexie {
  uploadRecords!: Table<UploadRecord, string>;
  bulkJobProgress!: Table<BulkJobProgress, string>;

  constructor() {
    super('onboarding_uploads');
    this.version(1).stores({
      uploadRecords: 'fileId, status',
    });
    this.version(2).stores({
      uploadRecords: 'fileId, status',
      bulkJobProgress: 'jobId, status, updatedAt',
    });
  }
}

export const onboardingDb = new OnboardingDB();
